import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export type InfoPageBase = {
	id: string;
	title: string;
	icon: string;
};

export interface InfoPageLink extends InfoPageBase {
	pageType: "link";
	content: {
		href: string;
	};
};

export interface InfoPageText extends InfoPageBase {
	pageType: "text";
	content: any;
};

export type InfoPage = InfoPageLink | InfoPageText;

export default function Info() {
	const [infoPages, setInfoPages] = useState<InfoPage[]>([]);

	async function fetchPages() {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/info`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const data = await res.json();

		if (!res.ok) {
			console.error(data.message);
			return;
		}

		setInfoPages(data);
	}

	async function deletePage(id: string) {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/info/${id}`, {
			method: 'DELETE'
		});

		if (!res.ok) {
			const data = await res.json();
			console.error(data.message);
		}

		fetchPages();
	}

	useEffect(() => {
		fetchPages();
	}, []);

	return (
		<div>
			<h1>Info Pages</h1>
			{/* This is used to display the icons */}
			<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@24,400,1,0" />
			<div className="news container container-lg" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
				{infoPages.map((infoPage) => {
					return (
						<div key={infoPage.id} className={'info'} style={{ border: "1px solid", borderColor: "black", borderRadius: "5px", margin: 5, padding: 5, width: "50%" }}>
							<div className={'title'}>
								<span className="material-symbols-outlined">
									{infoPage.icon.replaceAll("-", "_")}
								</span>
								{infoPage.title}
							</div>
							<Link to={{ pathname: "/info/" + infoPage.id }}><Button variant="primary">Edit</Button></Link>
							<Button variant="danger" onClick={() => deletePage(infoPage.id)}>Delete</Button>
						</div>
					);
				})}
			</div>
			<Link to="/newInfo"><Button>Create</Button></Link>
		</div>
	);
}
